export default {
    logoLight: null,
    logoDark: null,
}
